import { render, staticRenderFns } from "./DataColumnsSettings.vue?vue&type=template&id=65d0683e"
import script from "./DataColumnsSettings.vue?vue&type=script&lang=js"
export * from "./DataColumnsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports